import { render, staticRenderFns } from "./LaoKYC.vue?vue&type=template&id=e456ac1c&"
import script from "./LaoKYC.vue?vue&type=script&lang=js&"
export * from "./LaoKYC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports